import React from "react";
import Seo from "@/components/Seo";
import PhotoBackdrop from "@/components/PhotoBackdrop";
import Breadcrumb from "@/components/Breadcrumb";
import CTABanner from "@/components/CTABanner";
import ArticleCard from "@/components/cards/ArticleCard";
import { INSIGHTS, asCard } from "@/data/insights";

const InsightsIndex = () => (
  <div data-testid="insights-index-page">
    <Seo
      title="Insights"
      description="Practical, UK-focused engineering insights from Lutrom Engineering — EICRs, PPM, PLCs, control panels and industrial maintenance guidance from working engineers."
      path="/insights"
    />

    <section className="relative overflow-hidden">
      <PhotoBackdrop src="/gallery/workshop.jpg" position="center 45%" />
      <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-20 lg:pt-28 pb-14 lg:pb-20 relative">
        <p className="eyebrow">Insights</p>
        <h1
          className="font-display mt-6 text-white"
          style={{ fontSize: "clamp(40px, 5.5vw, 76px)", lineHeight: 0.98 }}
          data-testid="insights-heading"
        >
          FIELD NOTES FROM
          <br />
          <span className="gradient-blue-text">WORKING ENGINEERS.</span>
        </h1>
        <p className="mt-6 max-w-3xl text-[16px] leading-relaxed text-[color:var(--lt-text-dim)]">
          Practical guides on the engineering questions we get asked most —
          EICR preparation, PPM strategy, PLC service intervals, control panel
          procurement. Written by the team on the tools.
        </p>
      </div>
    </section>

    <Breadcrumb items={[{ label: "Insights" }]} />

    <section
      className="max-w-7xl mx-auto px-5 lg:px-10 mt-16 mb-24"
      data-testid="insights-grid"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {INSIGHTS.map((a) => (
          <ArticleCard key={a.slug} {...asCard(a)} />
        ))}
      </div>
    </section>

    <CTABanner
      variant="standard"
      title="Want engineering help — not just an article?"
      body="Talk to a working engineer about the specific job in front of you. Every enquiry gets a same-day human reply."
      phoneLocation="insights_index_cta"
    />
  </div>
);

export default InsightsIndex;
